import * as angular from 'angular';

import { IRequestService } from '../../services';

export interface IStatusService {
    updateStatusInputValues(): angular.IPromise<number>;
    updateStatusInputValuesAsync(): angular.IPromise<number>;
}

export class StatusService implements IStatusService {
    static serviceId = 'statusService';

    static $inject = ['requestService'];

    constructor(
        private _requestService: IRequestService) {
    }

    updateStatusInputValues(): angular.IPromise<number> {
        const url = this._requestService.getUrlV1() + 'status/updateStatusInputValues';
        this._requestService.cleanCache(url);
        return this._requestService.get(url);
    }

    updateStatusInputValuesAsync(): angular.IPromise<number> {
        const url = this._requestService.getUrlV1() + 'status/updateStatusInputValuesAsync';
        this._requestService.cleanCache(url);
        return this._requestService.get(url);
    }
}
